import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { StoreHistoryEcosystemResponseDto } from '@tiendanube/common';
import { useAppDispatch } from 'App/store';
import { convertStatusTypeToObject } from 'commons/utils/convertStatusTypeToObject';
import {
  fetchDevelopmentStoreHistory as fetchDevelopmentStoreHistoryAction,
  fetchDevelopmentStoreHistorySelector,
} from 'domains/Account/accountSlice';

interface UseDevelopmentStoreHistoryResult {
  storeHistory: StoreHistoryEcosystemResponseDto[];
  isDevelopmentStore: boolean;
  fetchDevelopmentStoreHistory: () => void;
  status: 'idle' | 'loading' | 'success' | 'error';
  isLoading: boolean;
  isError: boolean;
}

function useDevelopmentStoreHistory(): UseDevelopmentStoreHistoryResult {
  const { data: storeHistory, status: getStatus } = useSelector(
    fetchDevelopmentStoreHistorySelector,
  );
  const isDevelopmentStore =
    getStatus === 'success'
      ? storeHistory.some((store) => store.status === 'development')
      : false;

  const dispatch = useAppDispatch();

  const fetchDevelopmentStoreHistory = useCallback(() => {
    dispatch(fetchDevelopmentStoreHistoryAction());
  }, [dispatch]);

  return {
    fetchDevelopmentStoreHistory,
    storeHistory,
    isDevelopmentStore,
    status: getStatus,
    ...convertStatusTypeToObject(getStatus),
  };
}

export default useDevelopmentStoreHistory;
